<template>
  <!-- 患者検索 -->
  <div id="AppPatientManagementSleep">
    <!-- 上部余白 -->
    <div style="height: 10px" />

    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label"> 患者情報管理 </label>
          </div>
        </div>

        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="患者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientCode"
                name="patientCode"
                data-vv-as="患者コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="患者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientName"
                name="patientName"
                data-vv-as="患者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field
              label="患者名(カナ)"
              labelPosition="on-border"
              :type="{ 'is-danger': errors.has('patientNameKana') }"
              :message="errors.first('patientNameKana')"
            >
              <b-input
                v-model="searchConditions.patientNameKana"
                name="patientNameKana"
                data-vv-as="患者名(カナ)"
                type="text"
                field="patientNameKana"
                v-validate="'kanaCheck'"
                @typing="kanaInitialization()"
              ></b-input>
            </b-field>
          </div>
        </div>

        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalCode"
                name="hospitalCode"
                data-vv-as="医療機関コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalName"
                name="hospitalName"
                data-vv-as="医療機関名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>

        <!--3行目-->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業担当者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.salesOfficerCode"
                name="salesOfficerCode"
                data-vv-as="営業担当者コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="営業担当者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.salesOfficerName"
                name="salesOfficerName"
                data-vv-as="営業担当者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>

        <!--4行目-->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="品目コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productCode"
                name="productCode"
                data-vv-as="品目コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="品目名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productName"
                name="productName"
                data-vv-as="品目名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="シリアル" labelPosition="on-border">
              <b-input
                v-model="searchConditions.serialNumber"
                name="serialNumber"
                data-vv-as="シリアル"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>

        <!--5行目-->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="電話番号" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientPhone"
                name="patientPhone"
                data-vv-as="電話番号"
                type="text|max:20"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="郵便番号" labelPosition="on-border">
              <b-input
                v-model="searchConditions.zipCode"
                name="zipCode"
                data-vv-as="郵便番号"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="住所" labelPosition="on-border">
              <b-input
                v-model="searchConditions.address"
                name="address"
                data-vv-as="住所"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>

        <!--5行目-->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="支払人コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.payerCode"
                name="payerCode"
                data-vv-as="支払人コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="支払人名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.payerName"
                name="payerCode"
                data-vv-as="支払人名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="交換対象月" labelPosition="on-border">
              <b-datepicker
                v-model="searchConditions.replaceMonth"
                name="replaceMonth"
                type="month"
                placeholder="交換対象月"
                icon="calendar-today"
                :month-names="monthNames"
                :min-date="replaceMonthMin"
                :max-date="replaceMonthMax"
              >
                <button
                  class="button is-danger"
                  @click="(searchConditions.replaceMonth = null)"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
            </b-field>
          </div>
        </div>

        <!--6行目-->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="マスク品目コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.maskProductCode"
                name="maskProductCode"
                data-vv-as="マスク品目コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="マスク品目名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.maskProductName"
                name="maskProductName"
                data-vv-as="マスク品目名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="前回供給月" labelPosition="on-border">
              <b-datepicker
                v-model="searchConditions.lastDisposableMonth"
                name="lastDisposableMonth"
                type="month"
                placeholder="前回供給月"
                icon="calendar-today"
                :month-names="monthNames"
              >
                <button
                  class="button is-danger"
                  @click="(searchConditions.lastDisposableMonth = null)"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
            </b-field>
          </div>
        </div>

        <!-- 7行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field
              label="直送先種別"
              labelPosition="on-border"
              class="checkboxButtonField"
            >
              <b-checkbox-button
                v-model="searchConditions.directDestinationTypes"
                :native-value="directDestinationTypes.unjustifiable.code"
                >{{ directDestinationTypes.unjustifiable.name }}</b-checkbox-button
              >
              <b-checkbox-button
                v-model="searchConditions.directDestinationTypes"
                :native-value="directDestinationTypes.patientHome.code"
                >{{ directDestinationTypes.patientHome.name }}</b-checkbox-button
              >
              <b-checkbox-button
                v-model="searchConditions.directDestinationTypes"
                :native-value="directDestinationTypes.hospital.code"
                >{{ directDestinationTypes.hospital.name }}</b-checkbox-button
              >
              <b-checkbox-button
                v-model="searchConditions.directDestinationTypes"
                :native-value="directDestinationTypes.dealerDelivery.code"
                >{{ directDestinationTypes.dealerDelivery.name }}</b-checkbox-button
              >
            </b-field>
          </div>
          <div class="column">
            <b-field
              label="加湿器"
              labelPosition="on-border"
              class="checkboxButtonField"
            >
              <b-checkbox-button
                v-model="searchConditions.humidifierGroup"
                id="humidifierGroupCheck1"
                :native-value="1"
                >有り</b-checkbox-button
              >
              <b-checkbox-button
                v-model="searchConditions.humidifierGroup"
                id="humidifierGroupCheck0"
                :native-value="0"
                >無し</b-checkbox-button
              >
            </b-field>
          </div>
          <!-- CO連携（要件、サポート時期未定）
          <div class="column">
            <b-field
              label="CO/EA"
              labelPosition="on-border"
              class="checkboxButtonField"
            >
              <b-checkbox-button
                v-model="searchConditions.isCoGroup"
                id="coGroupCheck1"
                :native-value="1"
                >有り</b-checkbox-button
              >
              <b-checkbox-button
                v-model="searchConditions.isCoGroup"
                id="coGroupCheck0"
                :native-value="0"
                >無し</b-checkbox-button
              >
            </b-field>
          </div>
          -->
          <div class="column">
            <b-field
              label="供給漏れ"
              labelPosition="on-border"
              class="checkboxButtonField"
            >
              <b-checkbox-button
                v-model="searchConditions.isSupplyLeakedGroup"
                id="supplyLeakedGroupCheck1"
                :native-value="1"
                >有り</b-checkbox-button
              >
              <b-checkbox-button
                v-model="searchConditions.isSupplyLeakedGroup"
                id="supplyLeakedGroupCheck0"
                :native-value="0"
                >無し</b-checkbox-button
              >
            </b-field>
          </div>
          <div class="column">
            <b-field
              labelPosition="on-border"
              class="checkboxButtonField"
            >
              <template #label>
                <b-icon icon="account-alert"> </b-icon>
              </template>
              <b-checkbox-button
                v-model="searchConditions.interestPatientGroup"
                id="interestPatientGroupCheck1"
                :native-value="1"
                >有り</b-checkbox-button
              >
              <b-checkbox-button
                v-model="searchConditions.interestPatientGroup"
                id="interestPatientGroupCheck0"
                :native-value="0"
                >無し</b-checkbox-button
              >
            </b-field>
          </div>
          <div class="column">
            <b-field
              label="ﾌｫﾛｰｱｯﾌﾟｺｰﾙ"
              labelPosition="on-border"
              class="checkboxButtonField"
            >
              <b-checkbox-button
                v-model="searchConditions.followUpCallGroup"
                id="followUpCallGroupCheck1"
                :native-value="1"
                >有り</b-checkbox-button
              >
              <b-checkbox-button
                v-model="searchConditions.followUpCallGroup"
                id="followUpCallGroupCheck0"
                :native-value="0"
                >無し</b-checkbox-button
              >
            </b-field>
          </div>
          <div class="column">
            <b-field
              label="状態"
              labelPosition="on-border"
              class="checkboxButtonField"
            >
              <b-checkbox-button
                v-model="searchConditions.includeDeleted"
                id="includeDeletedGroupCheck1"
                :native-value="true"
                >削除含む</b-checkbox-button
              >
            </b-field>
          </div>
        </div>

        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align: center">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search()"
              >検索する</b-button
            >
          </div>
        </div>
        <div class="columns" style="text-align: center">
          <div class="column">
            <span
              style="color: red"
              v-if="
                isSearchConditionKana &&
                !this.kanaJudg(searchConditions.patientNameKana)
              "
              >検索条件に誤りがあります。</span
            >
            <span style="color: red" v-else-if="isSearchConditionNull"
              >検索条件を指定してください。</span
            >
            <span style="color: red" v-if="isSearchConditionAll"
              >全件検索となる為、検索条件を絞り込んでください。</span
            >
          </div>
        </div>
      </template>
    </div>

    <!-- 検索結果 -->
    <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
      <patientSearchResult
        v-model="searchResult"
        v-bind:searchConditions="searchConditions"
      />
    </div>

    <!-- 下部余白 -->
    <div style="height: 10px" />
  </div>
</template>

<script>
import resultTemplate from "./AppPatientManagementSleepResult";
import * as datetime from "../utils/datetime";
import * as patientUtils from "../utils/patient";
import * as user from "../utils/user";

export default {
  name: "AppPatientManagementSleep",

  computed: {
    replaceMonthMin: function() {
      const replaceMonthMin = new Date();
      replaceMonthMin.setDate(1);
      replaceMonthMin.setHours(0);
      replaceMonthMin.setMinutes(0);
      replaceMonthMin.setSeconds(0);
      replaceMonthMin.setMilliseconds(0);
      return replaceMonthMin;
    },

    replaceMonthMax: function() {
      let replaceMonthMax = new Date();
      replaceMonthMax.setMonth(replaceMonthMax.getMonth() + 2);
      return replaceMonthMax;
    },
  },
  
  methods: {
    search: function () {
      if (
        this.isLength(this.searchConditions.patientCode) ||
        this.isLength(this.searchConditions.patientName) ||
        this.isLength(this.searchConditions.patientNameKana) ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.payerCode) ||
        this.isLength(this.searchConditions.payerName) ||
        this.isLength(this.searchConditions.salesOfficerCode) ||
        this.isLength(this.searchConditions.salesOfficerName) ||
        this.isLength(this.searchConditions.productCode) ||
        this.isLength(this.searchConditions.productName) ||
        this.isLength(this.searchConditions.patientPhone) ||
        this.isLength(this.searchConditions.serialNumber) ||
        this.isLength(this.searchConditions.zipCode) ||
        this.isLength(this.searchConditions.address) ||
        this.isLength(this.searchConditions.maskProductCode) ||
        this.isLength(this.searchConditions.maskProductName) ||
        this.searchConditions.directDestinationTypes.length > 0 ||
        this.searchConditions.humidifierGroup.length > 0 ||
        this.searchConditions.isCoGroup.length > 0 ||
        this.searchConditions.isSupplyLeakedGroup.length > 0 ||
        this.searchConditions.interestPatientGroup.length > 0 ||
        this.searchConditions.followUpCallGroup.length > 0 ||
        this.searchConditions.includeDeleted ||
        !!this.searchConditions.replaceMonth ||
        !!this.searchConditions.lastDisposableMonth
      ) {
        if (
          this.searchConditions.patientNameKana &&
          this.isLength(this.searchConditions.patientNameKana) &&
          !this.kanaJudg(this.searchConditions.patientNameKana)
        ) {
          this.isSearchConditionKana = true;
        } else {
          console.log("検索条件あり");
          this.isSearchConditionNull = false;
          if (
            !this.isLength(this.searchConditions.patientCode) &&
            !this.isLength(this.searchConditions.patientName) &&
            !this.isLength(this.searchConditions.patientNameKana) &&
            !this.isLength(this.searchConditions.officeCode) &&
            !this.isLength(this.searchConditions.hospitalCode) &&
            !this.isLength(this.searchConditions.hospitalName) &&
            !this.isLength(this.searchConditions.payerCode) &&
            !this.isLength(this.searchConditions.payerName) &&
            !this.isLength(this.searchConditions.salesOfficerCode) &&
            !this.isLength(this.searchConditions.salesOfficerName) &&
            !this.isLength(this.searchConditions.productCode) &&
            !this.isLength(this.searchConditions.productName) &&
            !this.isLength(this.searchConditions.patientPhone) &&
            !this.isLength(this.searchConditions.serialNumber) &&
            !this.isLength(this.searchConditions.zipCode) &&
            !this.isLength(this.searchConditions.address) &&
            !this.isLength(this.searchConditions.maskProductCode) &&
            !this.isLength(this.searchConditions.maskProductName) &&
            !!!this.searchConditions.replaceMonth &&
            !!!this.searchConditions.lastDisposableMonth
          ) {
            if (
              this.isSearchAll(
                [this.searchConditions.directDestinationTypes.length, 4],
                [this.searchConditions.humidifierGroup.length, 2],
                [this.searchConditions.isCoGroup.length, 2],
                [this.searchConditions.isSupplyLeakedGroup.length, 2],
                [this.searchConditions.interestPatientGroup.length, 2],
                [this.searchConditions.followUpCallGroup.length, 2]
                [this.searchConditions.includeDeleted ? 1 : 0, 1]
              )
            ) {
              this.isSearchConditionAll = true;
              return;
            }
          }
          this.isSearchConditionAll = false;

          // 検索実行
          const excuteApi = this.getPatientListPOST;
          const successCallBack = this.getPatientListSuccess;
          const errorCallBack = this.getPatientListError;
          // WebAPI Call
          this.apiCall(excuteApi, successCallBack, errorCallBack, this.$store.state.subSystem);
        }
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
        this.isSearchConditionAll = false;
      }

      return;
    },

    getPatientListPOST: function (client) {
      const res = client.apis.apiPatient.getPatientListPOST({
        body: this.searchConditions,
      });

      return res;
    },

    getPatientListSuccess: function (result) {
      // WebAPI応答内容を画面に設定
      this.searchResult = result.obj;

      return;
    },

    getPatientListError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);

      return;
    },
  },
  data() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

    let roleId = userInfo.roleId;
    let searchConditions = {
      patientCode: "",
      patientName: "",
      patientNameKana: "",
      officeCode: "",
      hospitalCode: "",
      hospitalName: "",
      payerCode: "",
      payerName: "",
      salesOfficerCode: "",
      salesOfficerName: "",
      productCode: "",
      productName: "",
      patientPhone: "",
      serialNumber: "",
      zipCode: "",
      replaceMonth: null,
      address: "",
      maskProductCode: "",
      maskProductName: "",
      lastDisposableMonth: null,
      directDestinationTypes: [],
      humidifierGroup: [],
      isCoGroup: [],
      isSupplyLeakedGroup: [],
      interestPatientGroup: [],
      followUpCallGroup: [],
      includeDeleted: false,
    };
    if (
      this.$route.params["patientSearchFlag"] &&
      this.$route.params["searchConditions"] != undefined
    ) {
      searchConditions = this.$route.params["searchConditions"];
    } else {
      if (roleId != user.ROLE_ID_MAP.systemManager && roleId != user.ROLE_ID_MAP.callcenter) {
        searchConditions.officeCode = userInfo.officeCode;
        searchConditions.salesOfficerCode = userInfo.staffCode;
        searchConditions.salesOfficerName = userInfo.fullName;
      } else {
      }
    }
    return {
      monthNames: datetime.MONTHS,
      searchConditions,
      searchResult: [],
      isSearchConditionNull: true,
      isSearchConditionAll:false,
      isSearchConditionKana: false,
      userInfo,
      roleId,
      directDestinationTypes: patientUtils.DIRECT_DESTINATION_TYPE_MAP,
    };
  },
  filters: {},
  components: {
    patientSearchResult: resultTemplate,
  },
  mounted: function () {
    if(this.$route.params["patientSearchFlag"]){
      this.search(this.searchConditions);
    }
    return;
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppPatientManagementSleep.vue